/**
 * HEATSHABU — storefront behaviour, ported from the WordPress theme's main.js.
 *
 * Progressive throughout: the shop works with this file blocked (forms post
 * normally), and every block bails out quietly when its markup is absent.
 */
(function () {
  'use strict';

  var doc = document;
  var HS = window.HS || { routes: {} };
  var routes = HS.routes || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var root = (routes.root || '/').replace(/\/?$/, '/');

  /* ---------------------------------------------------------------
   * Exact brand search — Shopify equivalent of Zulnovar Hidden Search
   *
   * Keep the public query as the brand the customer entered. Brand result
   * handles live in hs-brand-index.js and cards are loaded 24 at a time.
   * This avoids exposing search syntax and prevents unrelated products from
   * Shopify's broad OR matching from appearing in the results.
   * ------------------------------------------------------------- */
  var brandKeyAliases = {
    'rolex': 'rolex',
    'ap': 'ap',
    'a p': 'ap',
    'audemars': 'ap',
    'audemars piguet': 'ap',
    'patek': 'patek',
    'patek philippe': 'patek',
    'omega': 'omega',
    'cartier': 'cartier',
    'hublot': 'hublot'
  };

  var brandGrid = doc.querySelector('[data-hs-brand-grid]');
  if (brandGrid) {
    var enteredBrand = String(brandGrid.getAttribute('data-brand-query') || '').trim().toLowerCase().replace(/\s+/g, ' ');
    var brandKey = brandKeyAliases[enteredBrand];
    var brandIndex = window.HS_BRAND_INDEX || {};
    var brandHandles = brandKey ? (brandIndex[brandKey] || []) : [];
    var brandPageSize = 24;
    var brandLoading = doc.querySelector('[data-hs-brand-loading]');
    var brandPager = doc.querySelector('[data-hs-brand-pager]');

    function brandPageFromHash() {
      var match = String(window.location.hash || '').match(/^#brand-page=(\d+)$/);
      var page = match ? parseInt(match[1], 10) : 1;
      var max = Math.max(1, Math.ceil(brandHandles.length / brandPageSize));
      return Math.max(1, Math.min(page || 1, max));
    }

    function paintBrandPager(page) {
      if (!brandPager) { return; }
      var pages = Math.ceil(brandHandles.length / brandPageSize);
      if (pages < 2) { brandPager.hidden = true; return; }
      var html = '<ul class="page-numbers">';
      if (page > 1) { html += '<li><a class="prev page-numbers" href="#brand-page=' + (page - 1) + '" aria-label="Previous page">&larr;</a></li>'; }
      for (var n = 1; n <= pages; n += 1) {
        if (n === page) {
          html += '<li><span aria-current="page" class="page-numbers current">' + n + '</span></li>';
        } else if (n === 1 || n === pages || Math.abs(n - page) <= 2) {
          html += '<li><a class="page-numbers" href="#brand-page=' + n + '">' + n + '</a></li>';
        } else if (n === page - 3 || n === page + 3) {
          html += '<li><span class="page-numbers dots">&hellip;</span></li>';
        }
      }
      if (page < pages) { html += '<li><a class="next page-numbers" href="#brand-page=' + (page + 1) + '" aria-label="Next page">&rarr;</a></li>'; }
      brandPager.innerHTML = html + '</ul>';
      brandPager.hidden = false;
    }

    function renderBrandPage(scrollToResults) {
      var page = brandPageFromHash();
      var start = (page - 1) * brandPageSize;
      var handles = brandHandles.slice(start, start + brandPageSize);
      brandGrid.innerHTML = '';
      if (brandLoading) { brandLoading.hidden = false; brandLoading.textContent = 'Loading watches…'; }
      paintBrandPager(page);

      Promise.all(handles.map(function (handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        var html = cards.filter(function (card) { return card.indexOf('hs-card') !== -1; }).join('');
        brandGrid.innerHTML = html;
        if (brandLoading) {
          brandLoading.hidden = !!html;
          if (!html) { brandLoading.textContent = 'No matching watches are available.'; }
        }
        paintWish(wishlist);
        if (scrollToResults) { brandGrid.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
      });
    }

    window.addEventListener('hashchange', function () { renderBrandPage(true); });
    renderBrandPage(false);
  }

  /* ---------------------------------------------------------------
   * Money, in the shop's own format
   * ------------------------------------------------------------- */
  function money(cents) {
    var fmt = HS.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    var withDelims = function (num, dec, th, dp) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dp);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  /* ---------------------------------------------------------------
   * Header shadow once the page scrolls
   * ------------------------------------------------------------- */
  var header = doc.querySelector('.js-header');
  if (header) {
    var stuck = null;
    var onScroll = function () {
      var s = window.scrollY > 4;
      if (s !== stuck) { header.classList.toggle('is-stuck', s); stuck = s; }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------------
   * Category panel — click to toggle, hover on desktop
   * ------------------------------------------------------------- */
  var dept = doc.querySelector('.js-dept');
  if (dept) {
    var deptBtn = dept.querySelector('.js-dept-btn');
    var hoverTimer = null;
    var setDept = function (open) {
      dept.classList.toggle('is-open', open);
      if (deptBtn) { deptBtn.setAttribute('aria-expanded', String(open)); }
    };
    if (deptBtn) {
      deptBtn.addEventListener('click', function () { setDept(!dept.classList.contains('is-open')); });
    }
    if (window.matchMedia('(hover: hover)').matches) {
      dept.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { setDept(true); }, 120); });
      dept.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { setDept(false); }, 180); });
    }
    doc.addEventListener('click', function (e) { if (!dept.contains(e.target)) { setDept(false); } });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setDept(false); } });
  }

  /* ---------------------------------------------------------------
   * Mobile drawer — opened from the header menu button and from
   * "Categories" in the bottom navigation
   * ------------------------------------------------------------- */
  var drawer = doc.querySelector('.js-drawer');
  var scrim = doc.querySelector('.js-drawer-scrim');
  var openBtns = doc.querySelectorAll('.js-drawer-open');

  function setDrawer(open) {
    if (!drawer || !scrim) { return; }
    if (open) {
      drawer.hidden = false;
      scrim.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        scrim.classList.add('is-open');
      });
      doc.body.style.overflow = 'hidden';
    } else {
      drawer.classList.remove('is-open');
      scrim.classList.remove('is-open');
      doc.body.style.overflow = '';
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) { drawer.hidden = true; scrim.hidden = true; }
      }, 300);
    }
    each(openBtns, function (b) { b.setAttribute('aria-expanded', String(open)); });
  }
  each(openBtns, function (b) {
    b.addEventListener('click', function (e) {
      if (!drawer || !scrim) { return; }
      e.preventDefault();
      setDrawer(true);
    });
  });
  if (scrim) { scrim.addEventListener('click', function () { setDrawer(false); }); }
  each(doc.querySelectorAll('.js-drawer-close'), function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) { setDrawer(false); }
  });
  each(doc.querySelectorAll('.js-drawer-toggle'), function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) { return; }
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------------------------------------------------------------
   * Mobile filter sheet on results pages
   * ------------------------------------------------------------- */
  var facets = doc.querySelector('.js-filters');
  var facetScrim = doc.querySelector('.hs-facets-scrim');
  if (facets) {
    each(doc.querySelectorAll('.js-filters-toggle'), function (btn) {
      btn.addEventListener('click', function () {
        var open = !facets.classList.contains('is-open');
        facets.classList.toggle('is-open', open);
        if (facetScrim) { facetScrim.hidden = !open; }
        doc.body.style.overflow = open ? 'hidden' : '';
        each(doc.querySelectorAll('.hs-pill--filter'), function (p) { p.setAttribute('aria-expanded', String(open)); });
      });
    });
  }

  /* ---------------------------------------------------------------
   * Sort order on collection pages
   * ------------------------------------------------------------- */
  each(doc.querySelectorAll('.js-sort'), function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------------------------------------------------------------
   * Wishlist — a cookie of product handles, so it works without an account
   * ------------------------------------------------------------- */
  function readWishlist() {
    var m = doc.cookie.match(/(?:^|;\s*)hs_wishlist=([^;]*)/);
    return m ? decodeURIComponent(m[1]).split(',').filter(function (h) { return /^[\w-]+$/.test(h); }) : [];
  }
  function writeWishlist(ids) {
    doc.cookie = 'hs_wishlist=' + encodeURIComponent(ids.join(',')) + ';path=/;max-age=31536000;samesite=lax';
  }
  function paintWish(ids) {
    each(doc.querySelectorAll('.js-wish-count'), function (el) {
      el.textContent = String(ids.length);
      el.setAttribute('data-count', String(ids.length));
    });
    each(doc.querySelectorAll('.js-wish'), function (btn) {
      var on = ids.indexOf(btn.dataset.id) !== -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
      var label = btn.querySelector('span');
      if (label && btn.classList.contains('hs-buy__save')) {
        label.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
      }
    });
  }
  var wishlist = readWishlist();
  paintWish(wishlist);

  doc.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-wish') : null;
    if (!btn) { return; }
    e.preventDefault();
    var id = btn.dataset.id;
    var at = wishlist.indexOf(id);
    if (at === -1) { wishlist.push(id); } else { wishlist.splice(at, 1); }
    writeWishlist(wishlist);
    paintWish(wishlist);
    // On the wishlist page an un-hearted card leaves the list straight away.
    if (at !== -1 && wishGrid) {
      var card = btn.closest('.hs-card');
      if (card) { card.remove(); }
      if (!wishGrid.querySelector('.hs-card')) { wishGrid.hidden = true; if (wishEmpty) { wishEmpty.hidden = false; } }
    }
  });

  var wishGrid = doc.querySelector('.js-wish-grid');
  var wishEmpty = doc.querySelector('.js-wish-empty');
  if (wishGrid && wishlist.length) {
    Promise.all(wishlist.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.filter(function (c) { return c.indexOf('hs-card') !== -1; }).join('');
      if (!html) { return; }
      wishGrid.innerHTML = html;
      wishGrid.hidden = false;
      if (wishEmpty) { wishEmpty.hidden = true; }
      paintWish(wishlist);
    });
  }

  /* ---------------------------------------------------------------
   * Cart badges, header total and the added-to-cart flyout
   * ------------------------------------------------------------- */
  function paintCart(cart) {
    if (!cart) { return; }
    each(doc.querySelectorAll('.js-cart-count'), function (b) {
      b.textContent = String(cart.item_count);
      b.setAttribute('data-count', String(cart.item_count));
    });
    each(doc.querySelectorAll('.js-cart-total'), function (t) { t.textContent = money(cart.total_price); });
  }
  function refreshCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCart(cart); return cart; })
      .catch(function () {});
  }
  // A page restored from the back/forward cache can show a stale count,
  // and a "Buy now" button left spinning on the way to checkout.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }
    refreshCart();
    if (cd) { cdLoad(); }
    each(doc.querySelectorAll('.js-buy-now, .js-stickybuy-now'), function (b) {
      if (b.classList.contains('loading')) { b.classList.remove('loading'); b.disabled = false; }
    });
  });

  var flyout = doc.querySelector('.js-added');
  var flyTimer = null;

  function showAdded(img, name, msg) {
    if (!flyout) { return; }
    var imgEl = flyout.querySelector('.js-added-img');
    var nameEl = flyout.querySelector('.js-added-name');
    var msgEl = flyout.querySelector('.js-added-msg');
    if (imgEl && img) { imgEl.src = img; }
    if (nameEl) { nameEl.textContent = name || ''; }
    if (msgEl) { msgEl.textContent = msg || 'Added to your cart'; }
    flyout.hidden = false;
    clearTimeout(flyTimer);
    flyTimer = setTimeout(function () { flyout.hidden = true; }, 6000);
  }
  if (flyout) {
    flyout.addEventListener('mouseenter', function () { clearTimeout(flyTimer); });
    flyout.addEventListener('mouseleave', function () { flyTimer = setTimeout(function () { flyout.hidden = true; }, 2500); });
    each(flyout.querySelectorAll('.js-added-close'), function (b) { b.addEventListener('click', function () { flyout.hidden = true; }); });
  }

  /* ---------------------------------------------------------------
   * Cart drawer — slides in from the right (sections/hs-cart-drawer).
   * Opens after an add to cart and from the cart icons; every change
   * swaps in a fresh copy of the section, so Liquid stays the single
   * source of truth for prices and discounts. The cart page keeps its
   * own editor, so the drawer is left out there.
   * ------------------------------------------------------------- */
  var CD_SECTION = 'hs-cart-drawer';
  var cd = doc.querySelector('.js-cd');
  var cdScrim = doc.querySelector('.js-cd-scrim');
  var cdReturn = null;
  var useDrawer = !!cd && !doc.querySelector('.js-cart-root');

  function cdSwap(html) {
    if (!cd || !html) { return; }
    var tmp = doc.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.js-cd-inner');
    var inner = cd.querySelector('.js-cd-inner');
    if (!fresh || !inner) { return; }
    // Keep keyboard focus on the same stepper button after the swap.
    var active = doc.activeElement;
    var hadFocus = !!active && cd.contains(active);
    var again = '';
    if (hadFocus && active.dataset && active.dataset.line && active.getAttribute('aria-label')) {
      again = '[data-line="' + active.dataset.line + '"][aria-label="' + active.getAttribute('aria-label') + '"]';
    }
    inner.innerHTML = fresh.innerHTML;
    if (hadFocus) {
      var target = again ? inner.querySelector(again) : null;
      (target || cd).focus();
    }
  }
  function cdLoad() {
    return fetch(root + '?sections=' + CD_SECTION, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { cdSwap(data && data[CD_SECTION]); })
      .catch(function () {});
  }
  function cdMessage(text) {
    var box = cd && cd.querySelector('.js-cd-msg');
    if (!box) { return; }
    box.textContent = text;
    box.hidden = false;
  }
  function cdOpen() {
    if (!cd || cd.classList.contains('is-open')) { return; }
    cdReturn = doc.activeElement;
    cd.hidden = false;
    if (cdScrim) { cdScrim.hidden = false; }
    void cd.offsetWidth;
    cd.classList.add('is-open');
    if (cdScrim) { cdScrim.classList.add('is-open'); }
    doc.body.style.overflow = 'hidden';
    var closeBtn = cd.querySelector('.js-cd-close');
    (closeBtn || cd).focus({ preventScroll: true });
  }
  function cdClose() {
    if (!cd || !cd.classList.contains('is-open')) { return; }
    cd.classList.remove('is-open');
    if (cdScrim) { cdScrim.classList.remove('is-open'); }
    doc.body.style.overflow = '';
    setTimeout(function () {
      if (!cd.classList.contains('is-open')) {
        cd.hidden = true;
        if (cdScrim) { cdScrim.hidden = true; }
      }
    }, 320);
    if (cdReturn && cdReturn.focus && doc.contains(cdReturn)) { cdReturn.focus({ preventScroll: true }); }
    cdReturn = null;
  }
  function cdChange(line, qty) {
    if (!cd || !line || cd.classList.contains('is-busy')) { return; }
    cd.classList.add('is-busy');
    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: CD_SECTION })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          return cdLoad().then(function () {
            cdMessage(res.data && (res.data.description || res.data.message) || 'That change could not be saved. Please try again.');
          });
        }
        paintCart(res.data);
        var html = res.data && res.data.sections ? res.data.sections[CD_SECTION] : '';
        if (html) { cdSwap(html); return null; }
        return cdLoad();
      })
      .catch(function () { return cdLoad(); })
      .then(function () { cd.classList.remove('is-busy'); });
  }

  if (cd) {
    cd.addEventListener('click', function (e) {
      if (!e.target.closest) { return; }
      if (e.target.closest('.js-cd-close')) { cdClose(); return; }
      var step = e.target.closest('.js-cd-qty');
      if (!step) { return; }
      e.preventDefault();
      cdChange(parseInt(step.dataset.line, 10), Math.max(0, parseInt(step.dataset.qty, 10) || 0));
    });
    // Keep Tab inside the open drawer.
    cd.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') { return; }
      var list = Array.prototype.filter.call(
        cd.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!list.length) { return; }
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && (doc.activeElement === first || doc.activeElement === cd)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && doc.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
    if (cdScrim) { cdScrim.addEventListener('click', cdClose); }
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { cdClose(); } });
  }
  if (useDrawer) {
    doc.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.js-cart-link, .js-cd-open') : null;
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) { return; }
      e.preventDefault();
      cdOpen();
    });
  }

  function onAdded(button, item, sections) {
    if (!reduceMotion) {
      each(doc.querySelectorAll('.js-cart-count'), function (badge) {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      });
    }
    if (button && button.classList) {
      button.classList.add('is-added');
      setTimeout(function () { button.classList.remove('is-added'); }, 2200);
    }

    if (useDrawer) {
      var html = sections ? sections[CD_SECTION] : '';
      if (html) {
        cdSwap(html);
        cdOpen();
      } else {
        cdLoad().then(cdOpen);
      }
      return;
    }

    // Cart page: refresh the page's own cart and confirm with the flyout.
    if (doc.querySelector('.js-cart-root')) { renderCart(); }
    var img = item && item.image ? item.image : '';
    if (img) { img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=160'; }
    showAdded(img, item ? item.product_title : '');
  }

  function postAdd(body) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }
  function addError(res) {
    return res && res.data && (res.data.description || res.data.message) || 'This item could not be added.';
  }

  function addToCart(body, button) {
    if (button) { button.classList.add('loading'); button.disabled = true; }
    // Ask Shopify to render the drawer in the same request.
    if (useDrawer) { body.sections = CD_SECTION; }
    return postAdd(body)
      .then(function (res) {
        if (button) { button.classList.remove('loading'); button.disabled = false; }
        if (!res.ok) {
          showAdded('', addError(res), 'Not added');
          return null;
        }
        var item = res.data && res.data.items ? res.data.items[0] : res.data;
        onAdded(button, item, res.data && res.data.sections);
        refreshCart();
        return item;
      })
      .catch(function () {
        if (button) { button.classList.remove('loading'); button.disabled = false; }
        return null;
      });
  }

  // "Buy now": add the item (and any paid add-ons), then go straight to checkout.
  function buyNow(body, button) {
    if (button) { button.classList.add('loading'); button.disabled = true; }
    return postAdd(body)
      .then(function (res) {
        if (!res.ok) {
          if (button) { button.classList.remove('loading'); button.disabled = false; }
          showAdded('', addError(res), 'Not added');
          return;
        }
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        if (button) { button.classList.remove('loading'); button.disabled = false; }
      });
  }

  // Round cart buttons on product cards.
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-add') : null;
    if (!btn) { return; }
    e.preventDefault();
    var id = parseInt(btn.dataset.variant, 10);
    if (!id || btn.classList.contains('loading')) { return; }
    addToCart({ items: [{ id: id, quantity: 1 }] }, btn);
  });

  /* ---------------------------------------------------------------
   * Product page: variant select, quantity steppers, AJAX add to cart,
   * Buy now
   * ------------------------------------------------------------- */
  function addSteppers(scope) {
    each((scope || doc).querySelectorAll('.quantity'), function (q) {
      var input = q.querySelector('input.qty[type="number"]');
      if (!input || q.querySelector('.qty-btn')) { return; }
      var down = doc.createElement('button');
      down.type = 'button';
      down.className = 'qty-btn qty-btn--down';
      down.setAttribute('aria-label', 'Decrease quantity');
      down.textContent = '−';
      var up = doc.createElement('button');
      up.type = 'button';
      up.className = 'qty-btn qty-btn--up';
      up.setAttribute('aria-label', 'Increase quantity');
      up.textContent = '+';
      q.insertBefore(down, q.firstChild);
      q.appendChild(up);
    });
  }
  addSteppers();

  doc.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.qty-btn') : null;
    if (!btn) { return; }
    var q = btn.closest('.quantity');
    var input = q && q.querySelector('input.qty');
    if (!input) { return; }
    var min = parseFloat(input.getAttribute('min') || '0');
    var step = parseFloat(input.getAttribute('step') || '1') || 1;
    var next = (parseFloat(input.value) || 0) + (btn.classList.contains('qty-btn--up') ? step : -step);
    var inCart = !!input.closest('.js-cart-form');
    if (!inCart && next < 1) { next = 1; }
    if (next < min) { next = min; }
    if (String(next) === input.value) { return; }
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var pform = doc.querySelector('.js-product-form');
  if (pform) {
    var idInput = pform.querySelector('.js-variant-id');
    var vsel = pform.querySelector('.js-variant');
    if (vsel && idInput) {
      vsel.addEventListener('change', function () {
        idInput.value = vsel.value;
        var opt = vsel.options[vsel.selectedIndex];
        if (opt && opt.dataset.price) {
          each(doc.querySelectorAll('.js-price'), function (p) { p.textContent = opt.dataset.price; });
        }
      });
    }
    var formBody = function () {
      var qty = parseInt((pform.querySelector('input.qty') || {}).value, 10) || 1;
      var mainItem = { id: parseInt(idInput.value, 10), quantity: qty };
      var addonItems = [];
      var addonNames = [];
      var addonWrap = pform.querySelector('[data-paid-addons]');
      var productTitle = addonWrap ? (addonWrap.getAttribute('data-product-title') || 'Main product') : 'Main product';
      each(pform.querySelectorAll('[data-paid-addon]:checked'), function (input) {
        var addonId = parseInt(input.getAttribute('data-addon-id'), 10);
        var addonName = input.getAttribute('data-addon-name') || 'Add-on';
        if (!addonId) { return; }
        addonNames.push(addonName);
        addonItems.push({
          id: addonId,
          quantity: qty,
          properties: {
            '_add_on_for': productTitle,
            '_add_on_type': addonName
          }
        });
      });
      if (addonNames.length) {
        mainItem.properties = { 'Paid add-ons': addonNames.join(', ') };
      }
      return { items: [mainItem].concat(addonItems) };
    };
    pform.addEventListener('submit', function (e) {
      var button = pform.querySelector('.js-add-form');
      if (!window.fetch || !idInput) { return; }
      e.preventDefault();
      if (button && button.classList.contains('loading')) { return; }
      addToCart(formBody(), button);
    });
    // Without JavaScript the button posts the form with return_to=/checkout.
    var buyBtn = pform.querySelector('.js-buy-now');
    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        if (!window.fetch || !idInput) { return; }
        e.preventDefault();
        if (buyBtn.classList.contains('loading')) { return; }
        buyNow(formBody(), buyBtn);
      });
    }
  }

  /* ---------------------------------------------------------------
   * Cart page — quantities over AJAX, then the section re-renders
   * ------------------------------------------------------------- */
  var cartRoot = doc.querySelector('.js-cart-root');
  function renderCart() {
    if (!cartRoot) { return Promise.resolve(); }
    var sid = cartRoot.getAttribute('data-section');
    return fetch(root + 'cart?section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = doc.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('.js-cart-root');
        if (fresh) {
          cartRoot.innerHTML = fresh.innerHTML;
          addSteppers(cartRoot);
        }
      });
  }
  function changeLine(line, qty) {
    if (cartRoot) { cartRoot.classList.add('is-busy'); }
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCart(cart); return renderCart(); })
      .catch(function () { window.location.reload(); })
      .then(function () { if (cartRoot) { cartRoot.classList.remove('is-busy'); } });
  }
  if (cartRoot) {
    var qtyTimer = null;
    cartRoot.addEventListener('change', function (e) {
      var input = e.target.closest ? e.target.closest('.js-line-qty') : null;
      if (!input) { return; }
      clearTimeout(qtyTimer);
      qtyTimer = setTimeout(function () {
        changeLine(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
      }, 500);
    });
    cartRoot.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.js-remove') : null;
      if (!link) { return; }
      e.preventDefault();
      if (link.classList.contains('js-save-later')) {
        var h = link.dataset.id;
        if (h && wishlist.indexOf(h) === -1) { wishlist.push(h); writeWishlist(wishlist); paintWish(wishlist); }
      }
      changeLine(parseInt(link.dataset.line, 10), 0);
    });
    cartRoot.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.classList || !f.classList.contains('js-discount')) { return; }
      e.preventDefault();
      var code = (f.querySelector('input[name="code"]') || {}).value || '';
      code = code.trim();
      if (!code) { return; }
      window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cart || '/cart');
    });
  }

  /* ---------------------------------------------------------------
   * Search-only watch pages — exact same-brand recommendations
   * ------------------------------------------------------------- */
  var relatedBrand = doc.querySelector('[data-hs-related-brand]');
  if (relatedBrand) {
    var currentHandle = relatedBrand.getAttribute('data-product-handle') || '';
    var relatedIndex = window.HS_BRAND_INDEX || {};
    var relatedLabels = {
      rolex: 'Rolex',
      ap: 'Audemars Piguet',
      patek: 'Patek Philippe',
      omega: 'Omega',
      cartier: 'Cartier',
      hublot: 'Hublot'
    };
    var relatedKey = '';
    Object.keys(relatedIndex).some(function (key) {
      if ((relatedIndex[key] || []).indexOf(currentHandle) !== -1) { relatedKey = key; return true; }
      return false;
    });

    var relatedTrack = relatedBrand.querySelector('[data-hs-related-track]');
    var relatedLoading = relatedBrand.querySelector('[data-hs-related-loading]');
    var relatedSeeAll = relatedBrand.querySelector('[data-hs-related-see-all]');
    if (relatedKey && relatedTrack) {
      var relatedHandles = relatedIndex[relatedKey].filter(function (handle) { return handle !== currentHandle; });
      var currentPosition = relatedIndex[relatedKey].indexOf(currentHandle);
      if (currentPosition > 0) {
        relatedHandles = relatedHandles.slice(currentPosition).concat(relatedHandles.slice(0, currentPosition));
      }
      relatedHandles = relatedHandles.slice(0, 24);

      if (relatedSeeAll) {
        relatedSeeAll.href = root + 'search?q=' + encodeURIComponent(relatedLabels[relatedKey] || relatedKey) + '&type=product';
      }
      Promise.all(relatedHandles.map(function (handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=card', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (cards) {
        var html = cards.filter(function (card) { return card.indexOf('hs-card') !== -1; }).map(function (card) {
          return '<div class="hs-shelf__cell">' + card + '</div>';
        }).join('');
        relatedTrack.innerHTML = html;
        if (relatedLoading) {
          relatedLoading.hidden = !!html;
          if (!html) { relatedLoading.textContent = 'No similar watches are available.'; }
        }
        paintWish(wishlist);
        window.dispatchEvent(new Event('resize'));
      });
    } else if (relatedLoading) {
      relatedLoading.textContent = 'No similar watches are available.';
    }
  }

  /* ---------------------------------------------------------------
   * Shelves — arrow buttons that page the row
   * ------------------------------------------------------------- */
  each(doc.querySelectorAll('.js-shelf'), function (shelf) {
    var track = shelf.querySelector('.js-shelf-track');
    var prev = shelf.querySelector('.js-shelf-prev');
    var next = shelf.querySelector('.js-shelf-next');
    if (!track) { return; }
    var paint = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) { prev.hidden = track.scrollLeft <= 2; }
      if (next) { next.hidden = track.scrollLeft >= max; }
    };
    var page = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' }); };
    if (prev) { prev.addEventListener('click', function () { page(-1); }); }
    if (next) { next.addEventListener('click', function () { page(1); }); }
    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  /* ---------------------------------------------------------------
   * FAQ accordion (support pages)
   * ------------------------------------------------------------- */
  each(doc.querySelectorAll('.js-faq-q'), function (btn) {
    btn.addEventListener('click', function () {
      var panel = doc.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) { return; }
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------------------------------------------------------------
   * Product gallery — thumbnails, arrows, counter, swipe
   * ------------------------------------------------------------- */
  var gallery = doc.querySelector('.js-p-gallery');
  if (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var counter = gallery.querySelector('.js-gallery-current');
    var gi = 0;
    var show = function (n) {
      if (slides.length < 2) { return; }
      slides[gi].classList.remove('is-active');
      if (thumbs[gi]) { thumbs[gi].classList.remove('is-active'); }
      gi = (n + slides.length) % slides.length;
      slides[gi].classList.add('is-active');
      if (thumbs[gi]) { thumbs[gi].classList.add('is-active'); }
      if (counter) { counter.textContent = String(gi + 1); }
    };
    each(thumbs, function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('mouseenter', function () { show(i); });
    });
    var gp = gallery.querySelector('.js-gallery-prev');
    var gn = gallery.querySelector('.js-gallery-next');
    if (gp) { gp.addEventListener('click', function () { show(gi - 1); }); }
    if (gn) { gn.addEventListener('click', function () { show(gi + 1); }); }

    var stage = gallery.querySelector('.p-gallery__stage');
    var x0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { show(gi + (dx < 0 ? 1 : -1)); }
        x0 = null;
      });
    }
  }

  /* ---------------------------------------------------------------
   * Mobile sticky "Add to cart" / "Buy now" bar on the product page
   * (scroll + getBoundingClientRect: IntersectionObserver misses jumps)
   * ------------------------------------------------------------- */
  var sticky = doc.querySelector('.js-stickybuy');
  var buyArea = doc.querySelector('.hs-buy__cart');
  if (sticky && buyArea) {
    var ticking = false;
    var paintSticky = function () {
      ticking = false;
      var past = buyArea.getBoundingClientRect().bottom < 0;
      if (past !== sticky.classList.contains('is-on')) {
        sticky.classList.toggle('is-on', past);
        sticky.setAttribute('aria-hidden', String(!past));
      }
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paintSticky); }
    }, { passive: true });
    paintSticky();
    var sb = sticky.querySelector('.js-stickybuy-btn');
    if (sb) {
      sb.addEventListener('click', function () {
        var real = buyArea.querySelector('.single_add_to_cart_button');
        if (real) { real.click(); }
      });
    }
    var sbNow = sticky.querySelector('.js-stickybuy-now');
    if (sbNow) {
      sbNow.addEventListener('click', function () {
        var real = buyArea.querySelector('.js-buy-now');
        if (real) { real.click(); }
      });
    }
  }
}());
